import React, { useState } from 'react';
import { formatCurrency } from '../../helpers/paymentsHelper';

const BottomToggleTable = ({
  data,
  current_week,
  previous_week
}) => {
  const [searchQuery, setSearchQuery] = useState('');



  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div className="w-full h-full">
      <div className="flex flex-row space-x-2">
        <div className="px-1" style={{ maxWidth: '220px' }}>
          <div className="relative flex items-center">
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ paddingTop: '0.44rem', paddingBottom: '0.44rem' }}
              className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div
        className="overflow-y-auto w-full scrollbar"
        style={{ maxHeight: '600px' }}>
        <table className="border-collapse w-full h-10/12">
          <thead>
            <tr>
              <th
                className="border-b p-2 cursor-pointer text-left">
               {" "}
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left">
               {" "}
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left font-semibold">
               Week {current_week}
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left font-semibold">
               Week {previous_week}
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left font-semibold">
               Variance
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => (
              <React.Fragment key={`${item.id} - ${item.company_name}`}>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                    {item.company_name}
                  </td>
                </tr>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                   {" "}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                    Payout
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.current.payout)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                   {formatCurrency(item.previous.payout)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    <div className="flex items-center justify-end gap-1">
                      {item.payout_variance}%
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.payout_variance === 0 ? 'hidden' : ''}
                      >
                        {item.payout_variance > 0 ? 
                          <path
                            d="M1.2729 10.9217L0.306803 9.98025C-0.102268 9.58163 -0.102268 8.93706 0.306803 8.54268L8.76237 0.298962C9.17144 -0.0996541 9.83291 -0.0996541 10.2376 0.298962L18.6932 8.53844C19.1023 8.93706 19.1023 9.58163 18.6932 9.97601L17.7271 10.9174C17.3137 11.3203 16.6391 11.3118 16.2344 10.9005L11.2429 5.79478V17.9823C11.2429 18.5463 10.7773 19 10.1985 19H8.80589C8.2271 19 7.76145 18.5463 7.76145 17.9823V5.79478L2.76557 10.9047C2.36086 11.3203 1.68633 11.3288 1.2729 10.9217Z"
                            fill="#00FF00"
                          /> :
                          <path 
                            d="M1.2729 8.07834L0.306803 9.01975C-0.102268 9.41837 -0.102268 10.0629 0.306803 10.4573L8.76237 18.701C9.17144 19.0997 9.83291 19.0997 10.2376 18.701L18.6932 10.4616C19.1023 10.0629 19.1023 9.41837 18.6932 9.02399L17.7271 8.08258C17.3137 7.67972 16.6391 7.6882 16.2344 8.09954L11.2429 13.2052V1.01774C11.2429 0.453745 10.7773 0 10.1985 0H8.80589C8.2271 0 7.76145 0.453745 7.76145 1.01774V13.2052L2.76557 8.0953C2.36086 7.67972 1.68633 7.67124 1.2729 8.07834Z" 
                            fill="#FF0000"
                          /> }
                      </svg>
                    </div>
                  </td>
                </tr>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {" "}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                   Access to Site
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.current.access_to_site)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.previous.access_to_site)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    <div className="flex items-center justify-end gap-1">
                      {item.access_variance}%
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.access_variance === 0 ? 'hidden' : ''}
                      >
                        {item.access_variance > 0 ? 
                          <path
                            d="M1.2729 10.9217L0.306803 9.98025C-0.102268 9.58163 -0.102268 8.93706 0.306803 8.54268L8.76237 0.298962C9.17144 -0.0996541 9.83291 -0.0996541 10.2376 0.298962L18.6932 8.53844C19.1023 8.93706 19.1023 9.58163 18.6932 9.97601L17.7271 10.9174C17.3137 11.3203 16.6391 11.3118 16.2344 10.9005L11.2429 5.79478V17.9823C11.2429 18.5463 10.7773 19 10.1985 19H8.80589C8.2271 19 7.76145 18.5463 7.76145 17.9823V5.79478L2.76557 10.9047C2.36086 11.3203 1.68633 11.3288 1.2729 10.9217Z"
                            fill="#00FF00"
                          /> :
                          <path 
                            d="M1.2729 8.07834L0.306803 9.01975C-0.102268 9.41837 -0.102268 10.0629 0.306803 10.4573L8.76237 18.701C9.17144 19.0997 9.83291 19.0997 10.2376 18.701L18.6932 10.4616C19.1023 10.0629 19.1023 9.41837 18.6932 9.02399L17.7271 8.08258C17.3137 7.67972 16.6391 7.6882 16.2344 8.09954L11.2429 13.2052V1.01774C11.2429 0.453745 10.7773 0 10.1985 0H8.80589C8.2271 0 7.76145 0.453745 7.76145 1.01774V13.2052L2.76557 8.0953C2.36086 7.67972 1.68633 7.67124 1.2729 8.07834Z" 
                            fill="#FF0000"
                          />}
                      </svg>
                    </div>
                  </td>
                </tr>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {" "}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                    Deduction
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.current.deduction)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.previous.deduction)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    <div className="flex items-center justify-end gap-1">
                      {item.deduction_variance}%
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.deduction_variance === 0 ? 'hidden' : ''}
                      >
                        {item.deduction_variance > 0 ? 
                          <path
                            d="M1.2729 10.9217L0.306803 9.98025C-0.102268 9.58163 -0.102268 8.93706 0.306803 8.54268L8.76237 0.298962C9.17144 -0.0996541 9.83291 -0.0996541 10.2376 0.298962L18.6932 8.53844C19.1023 8.93706 19.1023 9.58163 18.6932 9.97601L17.7271 10.9174C17.3137 11.3203 16.6391 11.3118 16.2344 10.9005L11.2429 5.79478V17.9823C11.2429 18.5463 10.7773 19 10.1985 19H8.80589C8.2271 19 7.76145 18.5463 7.76145 17.9823V5.79478L2.76557 10.9047C2.36086 11.3203 1.68633 11.3288 1.2729 10.9217Z"
                            fill="#00FF00"
                          /> :
                          <path 
                            d="M1.2729 8.07834L0.306803 9.01975C-0.102268 9.41837 -0.102268 10.0629 0.306803 10.4573L8.76237 18.701C9.17144 19.0997 9.83291 19.0997 10.2376 18.701L18.6932 10.4616C19.1023 10.0629 19.1023 9.41837 18.6932 9.02399L17.7271 8.08258C17.3137 7.67972 16.6391 7.6882 16.2344 8.09954L11.2429 13.2052V1.01774C11.2429 0.453745 10.7773 0 10.1985 0H8.80589C8.2271 0 7.76145 0.453745 7.76145 1.01774V13.2052L2.76557 8.0953C2.36086 7.67972 1.68633 7.67124 1.2729 8.07834Z" 
                            fill="#FF0000"
                          />}
                      </svg>
                    </div>
                  </td>
                </tr>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {" "}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                    Running Balance
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.current.running_balance)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {formatCurrency(item.previous.running_balance)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    <div className="flex items-center justify-end gap-1">
                      {item.balance_variance}%
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.balance_variance === 0 ? 'hidden' : ''}
                      >
                        {item.balance_variance > 0 ? 
                          <path
                            d="M1.2729 10.9217L0.306803 9.98025C-0.102268 9.58163 -0.102268 8.93706 0.306803 8.54268L8.76237 0.298962C9.17144 -0.0996541 9.83291 -0.0996541 10.2376 0.298962L18.6932 8.53844C19.1023 8.93706 19.1023 9.58163 18.6932 9.97601L17.7271 10.9174C17.3137 11.3203 16.6391 11.3118 16.2344 10.9005L11.2429 5.79478V17.9823C11.2429 18.5463 10.7773 19 10.1985 19H8.80589C8.2271 19 7.76145 18.5463 7.76145 17.9823V5.79478L2.76557 10.9047C2.36086 11.3203 1.68633 11.3288 1.2729 10.9217Z"
                            fill="#00FF00"
                          /> :
                          <path 
                            d="M1.2729 8.07834L0.306803 9.01975C-0.102268 9.41837 -0.102268 10.0629 0.306803 10.4573L8.76237 18.701C9.17144 19.0997 9.83291 19.0997 10.2376 18.701L18.6932 10.4616C19.1023 10.0629 19.1023 9.41837 18.6932 9.02399L17.7271 8.08258C17.3137 7.67972 16.6391 7.6882 16.2344 8.09954L11.2429 13.2052V1.01774C11.2429 0.453745 10.7773 0 10.1985 0H8.80589C8.2271 0 7.76145 0.453745 7.76145 1.01774V13.2052L2.76557 8.0953C2.36086 7.67972 1.68633 7.67124 1.2729 8.07834Z" 
                            fill="#FF0000"
                          />}
                      </svg>
                    </div>
                  </td>
                </tr>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {" "}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left font-semibold">
                   Total Trips
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.current.total_trips}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.previous.total_trips}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    <div className="flex items-center justify-end gap-1">
                      {item.trip_variance}%
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={item.trip_variance === 0 ? 'hidden' : ''}
                      >
                        {item.trip_variance > 0 ? 
                          <path
                            d="M1.2729 10.9217L0.306803 9.98025C-0.102268 9.58163 -0.102268 8.93706 0.306803 8.54268L8.76237 0.298962C9.17144 -0.0996541 9.83291 -0.0996541 10.2376 0.298962L18.6932 8.53844C19.1023 8.93706 19.1023 9.58163 18.6932 9.97601L17.7271 10.9174C17.3137 11.3203 16.6391 11.3118 16.2344 10.9005L11.2429 5.79478V17.9823C11.2429 18.5463 10.7773 19 10.1985 19H8.80589C8.2271 19 7.76145 18.5463 7.76145 17.9823V5.79478L2.76557 10.9047C2.36086 11.3203 1.68633 11.3288 1.2729 10.9217Z"
                            fill="#00FF00"
                          /> :
                          <path 
                            d="M1.2729 8.07834L0.306803 9.01975C-0.102268 9.41837 -0.102268 10.0629 0.306803 10.4573L8.76237 18.701C9.17144 19.0997 9.83291 19.0997 10.2376 18.701L18.6932 10.4616C19.1023 10.0629 19.1023 9.41837 18.6932 9.02399L17.7271 8.08258C17.3137 7.67972 16.6391 7.6882 16.2344 8.09954L11.2429 13.2052V1.01774C11.2429 0.453745 10.7773 0 10.1985 0H8.80589C8.2271 0 7.76145 0.453745 7.76145 1.01774V13.2052L2.76557 8.0953C2.36086 7.67972 1.68633 7.67124 1.2729 8.07834Z" 
                            fill="#FF0000"
                          />}
                      </svg>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BottomToggleTable;
